import { useEffect } from 'react'
import { formatTfHidden } from './typeform-live-embed.utils'

const TYPEFORM_SCRIPT_ID = 'typeform-live-embed-script'
const TYPEFORM_SCRIPT_SRC = 'https://embed.typeform.com/next/embed.js'

declare global {
  interface Window {
    tf?: {
      load?: () => void
    }
  }
}

export interface TypeformLiveEmbedProps {
  formId: string
  className?: string
  hiddenFields?: Record<string, string>
  ready?: boolean
}

export function TypeformLiveEmbed({ formId, className, hiddenFields, ready = true }: TypeformLiveEmbedProps) {
  useEffect(() => {
    if (!ready) {
      return
    }

    if (document.getElementById(TYPEFORM_SCRIPT_ID)) {
      window.tf?.load?.()
      return
    }

    const script = document.createElement('script')
    script.id = TYPEFORM_SCRIPT_ID
    script.src = TYPEFORM_SCRIPT_SRC
    script.async = true
    document.body.appendChild(script)
  }, [formId, ready])

  if (!ready) {
    return null
  }

  return (
    <div
      className={className}
      data-tf-live={formId}
      {...(hiddenFields !== undefined ? { 'data-tf-hidden': formatTfHidden(hiddenFields) } : {})}
    />
  )
}
